var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.00 0.00 435.00 141.00",
    width: 435,
    height: 141,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00b595",
    d: " M 420.49 0.00 Q 429.88 1.65 432.89 8.95 Q 434.28 12.33 434.27 22.73 Q 434.22 57.55 434.27 92.36 Q 434.28 102.99 432.75 106.47 Q 430.40 111.81 424.66 113.90 Q 421.59 115.01 414.25 115.01 Q 329.38 114.99 244.58 115.01 A 1.38 1.36 21.8 0 0 243.60 115.42 Q 233.54 125.53 230.32 128.89 Q 225.16 134.28 221.78 135.40 C 217.20 136.90 212.45 135.22 209.10 131.76 Q 208.73 131.38 193.48 115.97 Q 192.53 115.01 191.17 115.01 Q 108.27 114.99 25.15 115.01 Q 14.44 115.02 11.08 113.60 Q 5.70 111.34 3.50 105.64 Q 2.22 102.31 2.23 95.25 Q 2.28 56.00 2.24 16.76 Q 2.22 2.57 15.93 0.00 L 420.49 0.00 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChose);
export default __webpack_public_path__ + "static/media/chose.fc4e57ad6a035bac5fb0bae1c962abfe.svg";
export { ForwardRef as ReactComponent };